var _polyline, _path, _line, _polyline2, _line2, _line3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVentThruRoof({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Vent Thru Roof") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "3.96 8.84 7.52 7.41 7.52 4.21",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.58,1.89V6.55l3.62-1.5",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14.19,
    y1: 7.11,
    x2: 4.31,
    y2: 10.96,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "9.26 1.72 9.26 3.72 9.26 5.04",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9.25,
    y1: 6.62,
    x2: 9.25,
    y2: 9.74,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 9.25,
    y1: 10.77,
    x2: 9.25,
    y2: 14.05,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "translate(0.54 14.05)",
    fontSize: 3.49,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "0.03em",
    style: {
      isolation: "isolate"
    }
  }, "V"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(2.6 14.05)",
    fontSize: 3.49,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    fontFamily: "ArialMT, Arial",
    style: {
      isolation: "isolate"
    }
  }, "TR")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVentThruRoof);
export default __webpack_public_path__ + "static/media/VentThruRoof.ed76bcd796dc7f0c2624f5e33858ff34.svg";
export { ForwardRef as ReactComponent };